import React from 'react';
import { Card } from './styles';

const ConsultantCard = ({ title, description, value, color, year, margin }) => {
    if (year) {
        return (
            <Card elevation={0} height="197px" color={color} margin={margin}>
                <div>
                    <h2>{title}</h2>
                    <p>{description}</p>
                    <div>
                        <h1>{value}</h1>
                        <p>/ano</p>
                    </div>
                </div>
            </Card>
        );
    }

    return (
        <Card elevation={0} height="197px" color={color} margin={margin}>
            <div>
                <h2>{title}</h2>
                <p>{description}</p>
                <h1>{value}</h1>
            </div>
        </Card>
    );
};

export default ConsultantCard;
